import { Component } from 'react';
import { userData } from '../../Redux/services/generalService';
import service from '../../core/service';

interface IProps {
    dispatch?: any,
}
interface IState {
    active: number;
    loading?:boolean;
    showModal:boolean;
}

export class insuranceRateController extends Component<IProps, IState> {
    state: IState = {
        active: 1,
        loading:false,
        showModal:false
    };
    getProfile = () => {
        this.setState({loading:true})
        return async  (dispatch: any) => {
            try {
                const response = await service.User.profile();
                if (response) {
                    dispatch(userData(response?.data?.data));
                    this.setState({loading:false});
                }
            } catch (error: any) {
                this.setState({loading:false});
                if (error && error.status === 404) {
                  window.location.href = '/profile-not-found'
              }
            }
        };
    };
    closeModal = () => {
        this.setState({ showModal: false });
    };
}
export default insuranceRateController;